import MyTabsMenu from "components/elements/MyTabs/MyTabsMenu";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "../styles/WorkFlow.module.css";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentFlow } from "../slices/workFlowSlice";
import { Spin, Tabs } from "antd";



const WorkFlowMenu = ({
}) => {
    const { t, i18n } = useTranslation();
    const { workFlowTypeByGroup, currentFlow, isLoading } = useSelector((state) => state.workFlow);
    const dispatch = useDispatch();

    const MENU = useMemo(() => {
        if (workFlowTypeByGroup) {
            // console.log("i18n.language", i18n.language);

            return workFlowTypeByGroup?.map?.(o => {
                return {
                    label: o?.["name" + (i18n.language == 'en' ? "En" : "")],
                    key: o.workFlowType,
                }
            })
        }

        return []
    }, [workFlowTypeByGroup, i18n.language])

    return (
        <Tabs onChange={(e) => { dispatch(setCurrentFlow(e)) }} items={MENU}>
        </Tabs>

    );
};

export default WorkFlowMenu;
